import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import CategoriesTreeViewComponent from '../components/CategoriesTreeViewComponent';
import HeaderComponent from '../components/HeaderComponent';

class CategoriesTreeViewPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <CategoriesTreeViewComponent location={this.props.location}/>
            </div>
        );
    }
}

export default CategoriesTreeViewPage;